// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_container {
  width: 99.5%;
}
.header_container .header_main {
  width: 100%;
  height: 66px;
  background: #FFFFFF;
  display: flex;
  justify-content: space-between;
  background-color: #FFFFFF;
}
.header_container .header_main .menu-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
@media (min-width: 769px) {
  .header_container .header_main .menu-button {
    display: none;
  }
}
.header_container .tvs_logos {
  width: 18%;
  padding: 0rem 1rem;
}
.header_container .country-display {
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  padding: 6px;
}
.header_container .country-flag {
  border-radius: 0 !important;
  height: 20px !important;
}
.header_container .profile_text_image {
  position: relative;
  padding: 0rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0rem 1rem;
}
.header_container .profile_text_image img {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  cursor: pointer;
}
.header_container .logout_button {
  display: none;
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1;
}
.header_container .logout_button:hover {
  background-color: #f0f0f0;
}
.header_container .active {
  display: flex;
  align-items: center;
  gap: 5px;
}

.logout_btn {
  width: 20px !important;
  height: 20px !important;
}

@media screen and (max-width: 768px) {
  .tvs_logos {
    width: 130px !important;
  }
  .profile_text_image {
    gap: 0rem 10px !important;
  }
  .profile_text_image .country-name {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/Header/header.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,yBAAA;AACR;AACQ;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AACZ;AACY;EANJ;IAOQ,aAAA;EAEd;AACF;AAEI;EACI,UAAA;EACA,kBAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EAGA,YAAA;EACA,kBAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAJR;AAOI;EACI,2BAAA;EACA,uBAAA;AALR;AAQI;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AANR;AASI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAPR;AAUI;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,UAAA;AARR;AAUQ;EACI,yBAAA;AARZ;AAYI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAVR;;AAcA;EACI,sBAAA;EACA,uBAAA;AAXJ;;AAcA;EACI;IACI,uBAAA;EAXN;EAcE;IACI,yBAAA;EAZN;EAcM;IACI,aAAA;EAZV;AACF","sourcesContent":[".header_container {\n    width: 99.5%;\n\n    .header_main {\n        width: 100%;\n        height: 66px;\n        background: #FFFFFF;\n        display: flex;\n        justify-content: space-between;\n        background-color: #FFFFFF;\n\n        .menu-button {\n            background: none;\n            border: none;\n            font-size: 24px;\n            cursor: pointer;\n\n            @media (min-width: 769px) {\n                display: none;\n            }\n        }\n    }\n\n    .tvs_logos {\n        width: 18%;\n        padding: 0rem 1rem;\n    }\n\n    .country-display {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        // background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n        // box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border: none;\n        border-radius: 5px;\n        // color: #ffffff;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n        padding: 6px;\n    }\n\n    .country-flag {\n        border-radius: 0 !important;\n        height: 20px !important;\n    }\n\n    .profile_text_image {\n        position: relative;\n        padding: 0rem 1rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 0rem 1rem;\n    }\n\n    .profile_text_image img {\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        cursor: pointer;\n    }\n\n    .logout_button {\n        display: none;\n        position: absolute;\n        top: 80%;\n        left: 50%;\n        transform: translateX(-50%);\n        padding: 8px;\n        background-color: #fff;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        z-index: 1;\n\n        &:hover {\n            background-color: #f0f0f0;\n        }\n    }\n\n    .active {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n    }\n}\n\n.logout_btn {\n    width: 20px !important;\n    height: 20px !important;\n}\n\n@media screen and (max-width: 768px) {\n    .tvs_logos {\n        width: 130px !important;\n    }\n\n    .profile_text_image {\n        gap: 0rem 10px !important;\n\n        .country-name{\n            display: none;\n        }\n    }\n\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
